<template>
  <div class="subtitle-water">
    <div v-show="UserLevel<=0" class="subtitle-water-box" :style="waterStyle"></div>
    <div v-show="isShowWatermark()" class="subtitle-vip-mask" :style="vipMaskStyle">
      <div v-if="vipStyle.type != 'Horizontal'" class="contain-vips"></div>
      <div v-else>视频中含有VIP素材或功能</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      type: 'editor',
      bgUrl: '',
      width: 0,
      height: 0,
      posL: 0,
      posT: 0,
      vipStyle: {
        type: 'Horizontal',
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        fontSize: 140
      },
      timeout: null
    }
  },
  props: ["canvasSize"],
  computed: {
    ...mapGetters({
      editor: "TOOL",
      UserMsg: "UserMsg",
      IsVipSprites: "IsVipSprites",
      UserLevel: "UserLevel",
      subtitleEditor: "subtitle/subtitleEditor",
    }),
    waterStyle() {
      const style = {};
      style.width = this.width + 'px';
      style.height = this.height + 'px';
      style.top = this.posT + 'px';
      style.left = this.posL + 'px';
      style.background = `url("${this.bgUrl}") 50% 50% / 100% 100% no-repeat`;
      return style;
    },
    vipMaskStyle() {
      const style = {};
      style.width = this.vipStyle.width + 'px';
      style.top = this.vipStyle.top + 'px';
      style.fontSize = this.vipStyle.fontSize + 'px';
      style.height = this.vipStyle.height;
      style.left = this.vipStyle.left;
      return style;
    }
  },
  watch: {
    subtitleEditor() {
      this.initData();
    }
  },
  mounted() {
    this.initData()
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    initData() {
      if (!this.$route.subtitle) {
        this.type = "editor";
        this.vipStyle.type = this.editor.optimized;
        if(this.editor.optimized === 'Horizontal') {
          this.width = this.editor.clientWidth;
          this.posL = 0;
          this.bgUrl = '../../../../static/animengine/img/icon-default-watermark-h.png'
          this.vipStyle.width = this.width
          this.vipStyle.fontSize = 140 / this.editor.scale
          this.vipStyle.top = (this.editor.clientHeight - this.vipStyle.fontSize) / 2 - 40
          this.vipStyle.left = 0
          this.vipStyle.height = 'fit-content'
        } else {
          this.width = this.editor.clientHeight / 16 * 9;
          this.posL = (this.editor.clientWidth - this.width) / 2;
          this.bgUrl = '../../../../static/animengine/img/icon-default-watermark-v.png'
          this.vipStyle.top = 0;
          this.vipStyle.left = 0;
          this.vipStyle.width = this.editor.clientWidth
          this.vipStyle.height = this.editor.clientHeight + 'px'
        }
        this.height = this.editor.clientHeight;
        this.posT = 0;
      } else {
        this.type = "video";
        // 500*178 水印的宽高
        if(!this.subtitleEditor) return;
        let videoS = this.subtitleEditor.videoSize;
        let rateW = 500/178;
        let rate = videoS.width / videoS.height;
        if(rate >= 1) {
          this.height = videoS.height * 0.2;
          this.width = this.height * rateW;
        } else {
          this.width = videoS.width * 0.4;
          this.height = this.width / rateW;
        }
        this.posT = videoS.height - this.height + (this.canvasSize.height - videoS.height) / 2;
        this.posL = videoS.width - this.width + (this.canvasSize.width - videoS.width) / 2;
        this.bgUrl = '../../../../static/svg/subtitle/video-watermark.png'
      }
    },
    isShowWatermark() {
      if(this.type === 'video') return false;
      let shouldPay = !this.UserMsg.payForMaterial;
      return shouldPay && this.IsVipSprites && this.IsVipSprites.dataLength;
    },
    resize(){
      if(this.UserLevel<=0 || this.isShowWatermark()) {
        if(this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout( () => {
          this.initData()
        }, 500)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.subtitle-water {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.subtitle-water-box {
  position: absolute;
}
.subtitle-vip-mask {
  position: absolute;
  font-weight: bold;

  > div {
    color: #fff;
    opacity: 0.15;
    text-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
  }

  > div.contain-vips {
    width: 100%;
    height: 97%;
    margin-top: 1%;
    opacity: 1;
    background: url("../../../../static/animengine/img/icon-default-vip-mask.png")
      no-repeat center;
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/editCanvas/canvasWater.vue